export default "__VITE_PUBLIC_ASSET__3790917c__"